// src/Section/Home/Terravia.jsx

import React from "react";
import Banner from "../../Section/Home/Banner/banner.jsx";
import Desktop from "../../Media/Header/Desktop/Desktop_Tanakayu.webp";
import Mobile from "../../Media/Header/Mobile/Mobile_Vasya.webp";
import About from "../../Section/Detail/about/about.jsx";
import Promo from "../../Section/Home/Promo/promo.jsx";
import Lokasi from "../../Section/Home/Lokasi/lokasi.jsx";
import Tanakayudata from "./Tanakayu.json";
import promoData from "./promo.json";
import logo from "../Tanakayu/Tanakayulogo.png";
import hardsell from "../../Media/Promo/Hardsell_Tanakayu.webp";
import Produk from "../Tanakayu/Tanakayu/Tanakayu1.jsx";
import Fasilitas from "../../Section/Home/Fasilitas/fasilitas.jsx";
import Fasilitasdata from "./fasilitas.json"; // Ensure this path is correct
import Fasilitasimages from "../../Media/Fasilitas BSD/Tanakayu/Tanakayuf.js"; // Ensure this path is correct
import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";

const Tanakayu = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        logo={logo}
        judul={Tanakayudata.judul}
        Deskripsi={Tanakayudata.deskripsi}
      />
      <Promo
        image={hardsell}
        title={promoData.title}
        points={promoData.points}
        whatsapp={promoData.whatsapp}
      />
      <Produk />
      <Fasilitas
        title={Fasilitasdata.title}
        description={Fasilitasdata.description}
        facilities={Fasilitasdata.facilities}
        images={Fasilitasimages} // Pass images as a prop
      />
      <Surrounding />

      <Lokasi />
    </div>
  );
};

export default Tanakayu;
